import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const toTitleCase = (str: string) => {
  return str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export default function useTitle(title?: string) {
  const route = useRoute()
  const titleRef = ref(title)

  const moduleName = computed(() => {
    const path = route.path.split('/')[1]

    if (path === 'rnd') {
      return 'RND'
    }

    return path ? toTitleCase(path.replace(/-/g, '_')) : ''
  })

  watch(
    [titleRef, moduleName],
    ([newTitle, modName]) => {
      if (newTitle) {
        document.title = modName ? `${modName}: ${newTitle}` : newTitle
      }
    },
    { immediate: true }
  )

  return titleRef
}
